import { defineMessages } from 'react-intl'

const settingsMessages = defineMessages({
  feedback: {
    id: 'settings.feedback',
    defaultMessage: 'Feedback',
    description: 'The title used to submit a feedback.'
  },
  contactUs: {
    id: 'settings.contactUs',
    defaultMessage: 'Contact Us',
    description: 'The title used to submit a feedback.'
  },
  fitnessData: {
    id: 'settings.fitnessData',
    defaultMessage: 'Fitness Data',
    description: 'The title of the view and button used to show the user’s fitness data.'
  },
  equipmentList: {
    id: 'settings.equipmentList',
    defaultMessage: 'Equipment List',
    description: 'The title of the view and button used to show the user’s fitness data.'
  },
  units: {
    id: 'settings.units',
    defaultMessage: 'Units',
    description: 'The title of the view and button used to show the user’s units.'
  },
  themes: {
    id: 'settings.themes',
    defaultMessage: 'Themes',
    description: 'The title of the view and button used to show the user’s units.'
  },
  reportProblem: {
    id: 'settings.reportProblem',
    defaultMessage: 'Report a problem',
    description: 'The title of the view and button used to report a problem.'
  },
  question: {
    id: 'settings.question',
    defaultMessage: 'Question',
    description: 'The title of the view and button used to ask a question.'
  },
  generalFeedback: {
    id: 'settings.generalFeedback',
    defaultMessage: 'General feedback',
    description: 'The title of the view and button used to give a feedback.'
  },
  notifications: {
    id: 'settings.notifications',
    defaultMessage: 'Notifications',
    description: 'The notifications.'
  },
  system: {
    id: 'settings.system',
    defaultMessage: 'System',
    description: 'The system info'
  },
  yourSupportRequests: {
    id: 'settings.yourSupportRequests',
    defaultMessage: 'Support Requests',
    description: 'The title of the view and button used to show the user’s support requests.'
  }
})

export default settingsMessages
